import { Component, OnInit, TemplateRef, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { Location, DatePipe } from '@angular/common';
// import { proposalData } from '../personal-accident-proposal/proposal-data.model';
import { SharingDataService } from '../service/sharing-data.service';
import { ToasterService } from '../services/toaster.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from '../../environments/environment';
import { proposalData } from './health-insurance-proposal-data.model';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import moment from 'moment';

@Component({
  selector: 'app-health-insurance-proposal',
  templateUrl: './health-insurance-proposal.component.html',
  styleUrls: ['./health-insurance-proposal.component.css'],
  providers: [ToasterService]
})
export class HealthInsuranceProposalComponent implements OnInit {
  proposal: proposalData = new proposalData();
  modalRef: BsModalRef;
  thankyouSection: boolean;
  transactionFailureSection: boolean;
  // proposal: any ;
  adhaar: string;
  activeTab: string = 'proposerDetails';
  loading: boolean = false;
  royalStateList: any = [];
  royalCityList: any = [];
  quoteDetails: any;
  proposalTab: boolean = false;
  insurerDetails: boolean = true;
  nomineeDetails: boolean = true;
  healthDetails: boolean = true;
  totalMember: any;
  royalPremiumDetails: any;
  finalPremiumCheck: boolean = false;
  healthThankYou: boolean = false;
  selfProposalTab: boolean = false;
  spouseProposalTab: boolean = false;
  child1ProposalTab: boolean = false;
  child2ProposalTab: boolean = false;
  child3ProposalTab: boolean = false;
  DOBrequired: boolean;
  shouldBe18: boolean;
  public environment = environment;
  nomineeAddressAutoFillValue: string = "No";
  nomineeGaurdianDetails: boolean;
  nomineeDOBrequired: boolean = false;
  currentDate: Date;
  getGaurdianMinDate: Date;
  maxYearGaurdianDate: number;
  smokingInsurer1: string = "No";
  personFlag: any;
  paymentGateData: any = {};
  membersCount: any;
  diagYears: any = [];
  errorMsg: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  proposalForm: any = {
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
  }
  @ViewChild('royalSundarmForm', { static: true }) royalSundarmForm: ElementRef;
  birthYear: moment.Moment;

  constructor(private router: Router, private modalService: BsModalService, public datepipe: DatePipe, private serviceURLService: serviceURLService, public sharingDataService: SharingDataService, public toasterService: ToasterService) { }

  ngOnInit() {
    this.getStateCityForRoyal(1, '');
    this.quoteDetails = JSON.parse(sessionStorage.fhiProposal);
    this.membersCount = 1 + (this.quoteDetails.childSize ? +this.quoteDetails.childSize : 0) + (this.quoteDetails.isspouse ? 1 : 0);
    console.log(this.membersCount);
    // this.sharingDataService.familyHealthData.subscribe(data => 
    //   this.quoteDetails = data);
    if (this.quoteDetails) {
      this.getPremiumForRoyalSundram();
    }
    this.proposal.authorizedSignatoryDate = this.datepipe.transform(new Date(), 'dd/MM/yyyy')
    this.currentDate = new Date();
    this.getPrefilledData();
  }

  getPrefilledData() {
    const fullName = localStorage.getItem('name');
    const nameSplit = fullName.split(' ');
    this.proposal.firstName = nameSplit[0];
    this.proposal.email = localStorage.getItem('email');
    this.proposal.mobile = localStorage.getItem('mobileNumber');
  }

  getStateCityForRoyal(type, state) {
    this.loading = true;
    console.log(type, state);
    const cityData = {
      type: type,
      state: state,
    };

    this.serviceURLService.getCityStateForRoyalSundaram(cityData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      if (cityData.type === 1) {
        this.royalStateList = successData.data;
      } else {
        this.royalCityList = successData.data;
      }
    }, errorData => {
      this.loading = false;
    });
  }


  // we have make it common
  dateConvert(value: any) {
    let myMoment: moment.Moment = moment(value);
    const convertedValue = new Date(value).getTime();
    const newDate = new Date(convertedValue);
    const finalConvertDate = (newDate.getDate() + '/' + (newDate.getMonth() + 1) + '/' + newDate.getFullYear());
    return finalConvertDate;
  }


  getPremiumForRoyalSundram() {
    console.log('d', this.proposal.hospitalCashBenifit);
    var age = localStorage.getItem("familyAge");
    var birthYear = moment().subtract(age, 'years')
    this.DOBrequired = false;
    var regesterDate = new Date(this.proposal.dob);
    var ageDifMs = Date.now() - regesterDate.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    let ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (ageDifference < 18) {
      this.shouldBe18 = true;
    } else {
      this.shouldBe18 = false;
      this.loading = true;
      const proposalDetails = {
        sumInsured: 'Rs. ' + this.quoteDetails.quoteDetails.XLEW_2_7_4,
        totalMembers: '',
        adults: this.quoteDetails.isspouse ? + 2 : 1,
        childs: this.quoteDetails.childSize ? this.quoteDetails.childSize : 0,
        typeOfPlan: 'Supreme',
        insurerDob1: this.proposal.insurerDob1 ? this.dateConvert(this.proposal.insurerDob1) : this.dateConvert(birthYear),
        insurerDob2: this.proposal.insurerDob2 ? this.dateConvert(this.proposal.insurerDob2) : this.dateConvert(birthYear),
        city: this.proposal.city ? this.proposal.city : 'mumbai',
        hospitalCashBenifit: this.proposal.hospitalCashBenifit ? 'on' : 'off',
      }
      this.totalMember = proposalDetails.adults + JSON.parse(proposalDetails.childs);
      proposalDetails.totalMembers = this.totalMember;
      this.serviceURLService.getPremiumForRoyalSundram(proposalDetails).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.loading = false;
        this.royalPremiumDetails = successData.data;
        var finalPremium = this.royalPremiumDetails.finalPremium;
        
        if(finalPremium >= 50000.0){
          this.finalPremiumCheck = true;
          console.log(finalPremium);
        } else {
          console.log(this.finalPremiumCheck);
          this.finalPremiumCheck = false;
        }
      }, errorData => {
        this.loading = false;

      });
    }
  }

  calculateAge() {
    this.nomineeDOBrequired = false;
    var dobNominee = new Date(this.proposal.nomineeDob);
    var ageDifMs = Date.now() - dobNominee.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    let ageDifference = Math.abs(ageDate.getUTCFullYear() - 1970);
    if (ageDifference < 18) {
      this.nomineeGaurdianDetails = true;
    } else {
      this.nomineeGaurdianDetails = false;
    }
  }

  // calculate bmi based on height and weight
  calculateBmi(i) {
    const id = parseInt(i);
    switch (id) {
      case 1:
        var heightInMeter = this.proposal.height1 / 100;
        var weight = this.proposal.weight1;
        if (heightInMeter > 0 && weight > 1) {
          var bmi: any = weight / (heightInMeter * heightInMeter);
          if (bmi.length == 0 || bmi == 'Infinity')
            bmi = 0;
          bmi = bmi.toFixed(0);
          this.proposal.bmi1 = bmi;
        } else {
          bmi = 0;
          this.proposal.bmi1 = bmi;
        }
        break;
      case 2:
        var heightInMeter = this.proposal.height2 / 100;
        var weight = this.proposal.weight2;
        if (heightInMeter > 0 && weight > 1) {
          var bmi: any = weight / (heightInMeter * heightInMeter);
          if (bmi.length == 0 || bmi == 'Infinity')
            bmi = 0;
          bmi = bmi.toFixed(0);
          this.proposal.bmi2 = bmi;
        } else {
          bmi = 0;
          this.proposal.bmi2 = bmi;
        }
        break;
      case 3:
        var heightInMeter = this.proposal.height3 / 100;
        var weight = this.proposal.weight3;
        if (heightInMeter > 0 && weight > 1) {
          var bmi: any = weight / (heightInMeter * heightInMeter);
          if (bmi.length == 0 || bmi == 'Infinity')
            bmi = 0;
          bmi = bmi.toFixed(0);
          this.proposal.bmi3 = bmi;
        } else {
          bmi = 0;
          this.proposal.bmi3 = bmi;
        }
        break;
      case 4:
        var heightInMeter = this.proposal.height4 / 100;
        var weight = this.proposal.weight4;
        if (heightInMeter > 0 && weight > 1) {
          var bmi: any = weight / (heightInMeter * heightInMeter);
          if (bmi.length == 0 || bmi == 'Infinity')
            bmi = 0;
          bmi = bmi.toFixed(0);
          this.proposal.bmi4 = bmi;
        } else {
          bmi = 0;
          this.proposal.bmi4 = bmi;
        }
        break;
      case 5:
        var heightInMeter = this.proposal.height5 / 100;
        var weight = this.proposal.weight5;
        if (heightInMeter > 0 && weight > 1) {
          var bmi: any = weight / (heightInMeter * heightInMeter);
          if (bmi.length == 0 || bmi == 'Infinity')
            bmi = 0;
          bmi = bmi.toFixed(0);
          this.proposal.bmi5 = bmi;
        } else {
          bmi = 0;
          this.proposal.bmi5 = bmi;
        }
        break;
    }
  }

  saveOrSubmitProposalPage() {
    this.loading = true;
    if(this.proposal.insuredPersonGender1 === 'Mrs' || this.proposal.insuredPersonGender1 === 'MS') {
      this.proposal.insuredPersonGender1 = 'F';
    }
    this.proposal.totalMembers = this.totalMember;
    this.proposal.quoteId = this.quoteDetails.quoteId;
    this.proposal.quoteDetailId = this.quoteDetails.quoteDetailId;
    this.proposal.insurerName = "royalSundaram";
    this.proposal.sumInsured = 'Rs. ' + this.quoteDetails.quoteDetails.XLEW_2_2_5;
    this.proposal.age = this.quoteDetails.quoteDetails.XLEW_1_3_3;
    this.proposal.prospectId = this.quoteDetails.prospectId;
    this.proposal.productName = 'Family Health Insurance';
    this.proposal.premiumValIncludingTax = this.royalPremiumDetails.finalPremium;

    this.proposal.guardianRelationship1 = this.proposal.guardianRelationship1 ? this.proposal.guardianRelationship1 : ""
    this.proposal.guardianTitle = this.proposal.guardianTitle ? this.proposal.guardianTitle : ""
    this.proposal.guardianFirstName = this.proposal.guardianFirstName ? this.proposal.guardianFirstName : ""
    this.proposal.guardianLastName = this.proposal.guardianLastName ? this.proposal.guardianLastName : ""
    this.proposal.guardianAge = this.proposal.guardianAge ? this.proposal.guardianAge : ""
    this.proposal.guardianDob = this.proposal.guardianDob ? this.proposal.guardianDob : ""
    this.proposal.guardianMobile = this.proposal.guardianMobile ? this.proposal.guardianMobile : ""
    this.proposal.guardianAddress1 = this.proposal.guardianAddress1 ? this.proposal.guardianAddress1 : ""
    this.proposal.guardianAddress2 = this.proposal.guardianAddress2 ? this.proposal.guardianAddress2 : ""
    this.proposal.guardianPincode = this.proposal.guardianPincode ? this.proposal.guardianPincode : ""
    this.proposal.guardianCity = this.proposal.guardianCity ? this.proposal.guardianCity : ""
    this.proposal.guardianState = this.proposal.guardianState ? this.proposal.guardianState : ""
    this.proposal.physicianTitle = ""
    this.proposal.physicianName = ""
    this.proposal.physicianStdCode = ""
    this.proposal.physicianPhoneNumber = ""
    this.proposal.physicianMobileNumbe = ""
    this.proposal.nomineeAddressAutoFill = true ? "Yes" : "No"

    this.proposal.fromProposalPage = "true"
    this.proposal.hospitalCashBenifit = true ? "on" : "off"

    let proposalDob = this.datepipe.transform(this.proposal.dob, 'dd/MM/yyyy');
    this.proposal.dob = proposalDob

    let insurerDob1 = this.datepipe.transform(this.proposal.insurerDob1, 'dd/MM/yyyy');
    this.proposal.insurerDob1 = insurerDob1;

    let insurerDob2 = this.datepipe.transform(this.proposal.insurerDob2, 'dd/MM/yyyy');
    this.proposal.insurerDob2 = insurerDob2;

    let nomineeDob = this.datepipe.transform(this.proposal.nomineeDob, 'dd/MM/yyyy');
    this.proposal.nomineeDob = nomineeDob

    this.proposal.typeOfPlan = "Supreme"

    this.addtionalMedicalQuestion();

    console.log("save Data ", this.proposal);
    this.serviceURLService.familyHealthSaveProspect(this.proposal).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {


      this.loading = false;
      //this.healthThankYou = true;
      //this.healthDetails = true;
      //this.toasterService.showSuccessToaster(successData.data.message);
    }, errorData => {
      this.loading = false;

    });
  }

  // set diag year of add quest
  setDiagYearOfAddQuestions(dob) {
    let submityear = dob.getFullYear();
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    for (var i = submityear; i <= currentYear; i++) {
      this.diagYears.push(i);
    }
  }

  // check addition medical question check
  addtionalMedicalQuestion() {
    if (this.proposal.healthCheckUp1 === 'Yes' || this.proposal.healthDetailedInvestigation1 === 'Yes'
      || this.proposal.hospatalizedLastFiveYears1 === 'Yes' || this.proposal.insurarTakeMedicineOnRegularBasis1 === 'Yes'
      || this.proposal.insurerHealthProblemInLastThreeMonth1 === 'Yes' || this.proposal.insuredPersonTakenTreatmentOrHospitalized1 === 'Yes') {
      this.proposal.addtionalMedicalDetailCheck1 = 'Yes';
    }
    if (this.proposal.healthCheckUp2 === 'Yes' || this.proposal.healthDetailedInvestigation2 === 'Yes'
      || this.proposal.hospatalizedLastFiveYears2 === 'Yes' || this.proposal.insurarTakeMedicineOnRegularBasis2 === 'Yes'
      || this.proposal.insurerHealthProblemInLastThreeMonth2 === 'Yes' || this.proposal.insuredPersonTakenTreatmentOrHospitalized2 === 'Yes') {
      this.proposal.addtionalMedicalDetailCheck2 = 'Yes';
    }
    if (this.proposal.healthCheckUp3 === 'Yes' || this.proposal.healthDetailedInvestigation3 === 'Yes'
      || this.proposal.hospatalizedLastFiveYears3 === 'Yes' || this.proposal.insurarTakeMedicineOnRegularBasis3 === 'Yes'
      || this.proposal.insurerHealthProblemInLastThreeMonth3 === 'Yes' || this.proposal.insuredPersonTakenTreatmentOrHospitalized3 === 'Yes') {
      this.proposal.addtionalMedicalDetailCheck3 = 'Yes';
    }
    if (this.proposal.healthCheckUp4 === 'Yes' || this.proposal.healthDetailedInvestigation4 === 'Yes'
      || this.proposal.hospatalizedLastFiveYears4 === 'Yes' || this.proposal.insurarTakeMedicineOnRegularBasis4 === 'Yes'
      || this.proposal.insurerHealthProblemInLastThreeMonth4 === 'Yes' || this.proposal.insuredPersonTakenTreatmentOrHospitalized4 === 'Yes') {
      this.proposal.addtionalMedicalDetailCheck4 = 'Yes';
    }
    if (this.proposal.healthCheckUp5 === 'Yes' || this.proposal.healthDetailedInvestigation5 === 'Yes'
      || this.proposal.hospatalizedLastFiveYears5 === 'Yes' || this.proposal.insurarTakeMedicineOnRegularBasis5 === 'Yes'
      || this.proposal.insurerHealthProblemInLastThreeMonth5 === 'Yes' || this.proposal.insuredPersonTakenTreatmentOrHospitalized5 === 'Yes') {
      this.proposal.addtionalMedicalDetailCheck5 = 'Yes';
    }
  }

  royalSundramProceedToPay() {
    this.loading = true;
    if(this.proposal.insuredPersonGender1 === 'Mrs' || this.proposal.insuredPersonGender1 === 'MS') {
      this.proposal.insuredPersonGender1 = 'F';
    }
    this.proposal.totalMembers = this.totalMember;
    this.proposal.sumInsured = 'Rs. ' + this.quoteDetails.quoteDetails.XLEW_2_2_5;
    this.proposal.prospectId = this.quoteDetails.prospectId;
    this.proposal.typeOfPlan = "Supreme";
    this.proposal.age = this.quoteDetails.quoteDetails.XLEW_1_3_3;
    //this.proposal.insurerMemberRelation1 = 'Self';
    this.proposal.adults = this.quoteDetails.isspouse ? 2 : 1;
    this.proposal.childs = this.quoteDetails.childSize ? this.quoteDetails.childSize : 0;
    this.proposal.hospitalCashBenifit = this.proposal.hospitalCashBenifit ? 'on' : 'off';
    let proposalDob = this.datepipe.transform(this.proposal.dob, 'dd/MM/yyyy');
    this.proposal.dob = proposalDob;
    this.proposal.insurerName = 'royalSundaram';
    this.proposal.productName = 'Family Health Insurance';
    this.proposal.fromProposalPage = 'true';

    let insurerDob1 = this.datepipe.transform(this.proposal.insurerDob1, 'dd/MM/yyyy');
    this.proposal.insurerDob1 = insurerDob1;

    let insurerDob2 = this.datepipe.transform(this.proposal.insurerDob2, 'dd/MM/yyyy');
    this.proposal.insurerDob2 = insurerDob2;

    let insurerDob3 = this.datepipe.transform(this.proposal.insurerDob3, 'dd/MM/yyyy');
    this.proposal.insurerDob3 = insurerDob3;

    let insurerDob4 = this.datepipe.transform(this.proposal.insurerDob4, 'dd/MM/yyyy');
    this.proposal.insurerDob4 = insurerDob4;

    let insurerDob5 = this.datepipe.transform(this.proposal.insurerDob5, 'dd/MM/yyyy');
    this.proposal.insurerDob5 = insurerDob5;

    this.proposal.guardianDob = this.datepipe.transform(this.proposal.guardianDob, 'dd/MM/yyyy');

    this.proposal.nomineeDob = this.datepipe.transform(this.proposal.nomineeDob, 'dd/MM/yyyy');

    this.addtionalMedicalQuestion();

    this.serviceURLService.familyHealthFinalPremiumRoyalSundram(this.proposal).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.proccedtoPayment();
      //this.healthThankYou = true;
      //this.healthDetails = true;
      //this.toasterService.showSuccessToaster(successData.data.message);
    }, errorData => {
      this.loading = false;
      console.log('errorData', errorData);
      this.errorMsg = errorData.error.data.message;
      console.log(this.errorMsg);
    });
  }

  proccedtoPayment() {
    const sendPayData = {
      quoteId: this.quoteDetails.quoteId,
      email: this.proposal.email,
      quoteDetailId: this.quoteDetails.quoteDetailId,
      prospectId: this.quoteDetails.prospectId,
      insurerName: "royalSundaram",
      firstName: this.proposal.firstName
    }
    this.serviceURLService.proceedtoPayRoyalSundaram(sendPayData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.paymentGateData = successData.data;
      setTimeout(() => {
        this.royalSundarmForm.nativeElement.submit();
      }, 3000);
      //this.healthThankYou = true;
      //this.healthDetails = true;
      //this.toasterService.showSuccessToaster(successData.data.message);
    }, errorData => {
      this.loading = false;

    });
  }

  nextStep(tab) {
    console.log(this.proposal);
    if (tab === '1') {
      this.insurerDetails = false;
      var checkProposalFlag = sessionStorage.getItem('proposalInsuredFlag');
      this.personFlag = sessionStorage.getItem('proposalInsuredFlag');
      // common details prefilled in self tab

      //this.proposal.insuredPersonGender1 = this.proposal.title;
      this.proposal.insuredPersonFirstName1 = this.proposal.firstName;
      this.proposal.insuredPersonLastName1 = this.proposal.lastName;
      this.proposal.insurerDob1 = this.proposal.dob;

      if (checkProposalFlag == "1") {
        this.selfProposalTab = true;
      } else if (checkProposalFlag == "2") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
      } else if (checkProposalFlag == "3") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
        this.child1ProposalTab = true;
      } else if (checkProposalFlag == "4") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
        this.child1ProposalTab = true;
        this.child2ProposalTab = true;
      } else if (checkProposalFlag == "5") {
        this.selfProposalTab = true;
        this.spouseProposalTab = true;
        this.child1ProposalTab = true;
        this.child2ProposalTab = true;
        this.child3ProposalTab = true;
      }
      this.proposalTab = true;
      this.nomineeDetails = true;
      this.healthDetails = true;
    } else if (tab === '2') {
      this.insurerDetails = true;
      this.proposalTab = true;
      this.nomineeDetails = false;
      this.healthDetails = true;
    } else {
      this.insurerDetails = true;
      this.proposalTab = true;
      this.nomineeDetails = true;
      this.healthDetails = false;
    }
  }

  backtoprevTab(tab) {
    if (tab === '2') {
      this.insurerDetails = true;
      this.proposalTab = false;
    } else if (tab === '3') {
      this.insurerDetails = false;
      this.nomineeDetails = true;
    } else {
      this.nomineeDetails = false;
      this.healthDetails = true;
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false });
  }

  nomineeAddressAutoFill() {

    if (this.nomineeAddressAutoFillValue == "No") {
      this.nomineeAddressAutoFillValue = "Yes"
      this.proposal.nomineeAddress1 = this.proposal.address1;
      this.proposal.nomineePincode = this.proposal.pincode;
      this.proposal.nomineeState = this.proposal.state;
      this.proposal.nomineeCity = this.proposal.city;
    } else {
      this.nomineeAddressAutoFillValue = "No";
      this.proposal.nomineeAddress1 = "";
      this.proposal.nomineePincode = "";
      this.proposal.nomineeState = "";
      this.proposal.nomineeCity = "";
    }
  }

  getGaurdianMinDobDate(date) {
    // this.nomineeDOBrequired = false;
    var dobGaurdian = new Date(date);
    // var ageDifMsGaurdian = Date.now() - dobGaurdian.getTime();
    // var ageDateGaurdian = new Date(ageDifMsGaurdian); // miliseconds from epoch
    let ageDifferenceGaurdian = dobGaurdian.setFullYear(dobGaurdian.getFullYear() - 18);
    this.maxYearGaurdianDate = dobGaurdian.getFullYear();
    this.getGaurdianMinDate = new Date(ageDifferenceGaurdian);
  }

  getGaurdianAge(DOB) {
    let getDob = this.datepipe.transform(DOB, 'dd/MM/yyyy');
    var from = getDob.split("/");
    var today = new Date();
    var mydate = new Date(parseInt(from[2]), parseInt(from[1]) - 1, parseInt(from[0]));
    var age = today.getFullYear() - mydate.getFullYear();
    var m = today.getMonth() - mydate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < mydate.getDate())) {
      age--;
    }
    this.proposal.guardianAge1 = age;
    return age;
  }

  // this is for same value in mrs and ms case
  getGenderValue(event) {
    if(event.target.options.selectedIndex === 1) {
      this.proposal.insuredPersonGender1 = 'Mrs';
    } else if (event.target.options.selectedIndex === 2) {
      this.proposal.insuredPersonGender1 = 'MS';
    } else {
      this.proposal.insuredPersonGender1 = 'M';
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
